import React, { useState, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Button } from 'blocket-ui'

import { actionCreators as searchInputActionCreators } from 'reduxBits/searchInput'
import SearchInput from 'components/SearchInput'

export const StyledForm = styled.form`
  display: flex;
  flex: 1;
`

const StyledButton = styled(Button)`
  position: absolute;
  top: 0;
  right: 0;
  width: 52px;
  z-index: 1001;
  display: none;
  border-radius: 4px;
  border: 4px solid #fff;
  background-color: #fff;

  & :hover {
    display: block;
  }
  & button {
    border-radius: 2px;
    padding: 0;
    height: 32px;
    font-size: 15px;
    background-color: #4182c3;
  }
`

export const StyledInput = styled(SearchInput)`
  display: flex;
  flex: 1;
  height: 40px;
  margin-top: 0;
  margin-bottom: 0;

  > svg:first-child {
    padding-top: 12px;
  }

  & .input-focus {
    right: 60px;
    background-color: #fff;
  }

  & .react-autosuggest__container {
    position: relative;
    flex: 1;
    display: flex;
  }

  & .react-autosuggest__container input[value] {
    text-indent: 22px;
  }

  & .react-autosuggest__input {
    padding-left: 16px;
    border: none;
    height: 40px;

    &::placeholder {
      text-indent: 22px;
    }
  }

  & .react-autosuggest__input--open {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-bottom-width: 0;
  }

  & .react-autosuggest__suggestions-container--open {
    border-top: 1px solid #dfdede;
    border-right: none;
    border-bottom: none;
    border-left: none;
    top: 40px;
  }
`

export const Search = ({ onSubmit, placeholder, initialValue = '', ...props }) => {
  const [searchParams, setSearchParams] = useState({ q: initialValue })
  const dispatch = useDispatch()

  const handleSubmit = useCallback(
    (event) => {
      event.preventDefault()
      dispatch(searchInputActionCreators.updateHistory(searchParams.q))
      onSubmit(searchParams)
    },
    [onSubmit, searchParams, dispatch],
  )

  const handleSearchChange = useCallback(
    (newSearchParams, method) => {
      setSearchParams(newSearchParams)
      if (['suggestion', 'history'].includes(method)) {
        onSubmit(newSearchParams)
      }
    },
    [setSearchParams, onSubmit],
  )

  const handleInputReset = useCallback(() => {
    setSearchParams({ q: undefined })
  }, [setSearchParams])

  const renderInputComponent = (inputProps) => (
    <>
      <input {...inputProps} />
      <StyledButton aria-label="Sök" htmlType="submit" type="secondary" size="medium" tabIndex="-1">
        Sök
      </StyledButton>
    </>
  )

  return (
    <StyledForm data-cy="searchbox" onSubmit={handleSubmit} {...props}>
      <StyledInput
        onChange={handleSearchChange}
        onReset={handleInputReset}
        initialValue={initialValue}
        placeholder={placeholder}
        renderInputComponent={renderInputComponent}
        className="search-header"
      />
    </StyledForm>
  )
}

Search.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  initialValue: PropTypes.string,
  placeholder: PropTypes.string,
}

export default Search
